import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "@store/middleware";

import { getApplicationSpaBackendUrl } from "@utils";
import { type TProductType } from "@shared/types/product.types";

export interface ISendRequestCallLeadBody {
  phone: string;
  email?: string;
  name?: string;
  productsOfInterest: TProductType[];
}

export const REQUEST_CALL_API_REDUCER_KEY = "requestCallApi";
export const requestCallApi = createApi({
  reducerPath: REQUEST_CALL_API_REDUCER_KEY,
  baseQuery: (arguments_, api, extraOptions) =>
    baseQueryWithAuth({ baseUrl: getApplicationSpaBackendUrl() })(arguments_, api, {
      ...extraOptions,
      isExternalService: true,
    }),
  endpoints: (builder) => ({
    sendRequestCallLead: builder.mutation<void, ISendRequestCallLeadBody>({
      query: (body) => ({
        url: "/request-call",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useSendRequestCallLeadMutation } = requestCallApi;
